import { GenericTaskList } from "./generic-task-list";

interface DynamicTodoContentProps {
    /** Object type (opportunities, accounts, contacts, etc.) */
    objectType: string;
    /** Object ID */
    objectId: number;
}

/**
 * Component to display tasks in the dynamic tabs system
 * Passes objectType directly to GenericTaskList
 */
export function DynamicTodoContent({ objectType, objectId }: DynamicTodoContentProps) {
    return (
        <GenericTaskList
            objectType={objectType}
            objectId={objectId}
            title="Tasks"
            compact={false} // Full version for tabs
        />
    );
}
